import React, { useState } from 'react';
import 'bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import bg_dot_hero from '../assets/img/Illustrations/smaller_dots_bg_hero.avif';
import about_1 from '../assets/img/AboutUs/about_1.jpeg';
import about_2 from '../assets/img/AboutUs/about_2.jpg';
import about_2_2 from '../assets/img/AboutUs/about_2.2.jpg';
import about_3 from '../assets/img/AboutUs/about_3.jpg';
import about_4 from '../assets/img/AboutUs/vision_mission.jpg';
import about_5 from '../assets/img/AboutUs/about_4.jpeg';
import 'aos'
// import { Row, Col } from 'react-bootstrap';
import '../assets/css/style.css';
import '../assets/vendor/animate.css/animate.min.css';
import '../assets/vendor/aos/aos.css';
import '../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../assets/vendor/boxicons/css/boxicons.min.css';
import '../assets/vendor/glightbox/css/glightbox.min.css';
import '../assets/vendor/remixicon/remixicon.css';
import '../assets/vendor/swiper/swiper-bundle.min.css';
// import lab from '../assets/img/portfolio/Labiconicslogo.png'
import rabindranadth from '../assets/img/teams/ravee-removebg-preview.png'
import nbm from '../assets/img/teams/nbm1.png'
import birac from '../assets/img/teams/birac2.jpg'
import dbtlogo from '../assets/img/teams/dbtlogo.png'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faLightbulb, faCertificate, faBalanceScale, faUserCheck, faUsers, faSyncAlt, faAward, faTrophy, faMedal, faStar, faRibbon } from '@fortawesome/free-solid-svg-icons';
// import { RiDoubleQuotesL } from "react-icons/ri";
import qouteIcon from '../assets/img/quote.svg';

const About = () => {
    const [showAllAwards, setShowAllAwards] = useState(false);
    const awards = [
        {
            id: 1,
            title: 'India 500 Startup Award - 2019',
            description: 'Received the India 500 Startup Award in 2019 for outstanding achievements.'
        },
        {
            id: 2,
            title: 'MSMECCII Excellence Award - 2020',
            description: 'Recognized with the MSMECCII Excellence Award in 2020 for exemplary contributions.'
        },
        {
            id: 3,
            title: 'Best Innovative Technology Award - 2022',
            description: 'Won the Best Innovative Technology Award from ISAS in 2022 for groundbreaking advancements.'
        },
        {
            id: 4,
            title: 'Grant Award from NBM - BIRAC',
            description: 'Received a Grant Award from the National Biopharma Mission for the "Development of Quality Management System for Biopharmaceutical Industry".'
        }
        // Add more awards as needed
    ];
    const handleExploreAwardsClick = () => {
        setShowAllAwards(true);
    };
    return (<div className='portifoliobody'>
        <main >
            <section id="ABOUT" className="about text-start">
                <div className="blg-title">
                    <div className="blg-title-bg-img" style={{overflow:'hidden'}}><img src={bg_dot_hero} alt="" style={{ width:'inherit'}}/></div>
                    <div data-aos="fade-right" data-aos-delay="100">
                        <h1>About Us</h1>
                        <p>Learn more about who we are, what we do, and why we do it.</p>
                    </div>
                </div>

                <div className='about-us-section'>
                    <div className='about-us-wrapper'>
                        <div className='about-us-content'>
                            <div className='about-us-image'>
                                <div className="ab-images-placeholder">
                                    <div className='ab-img-1 carousel-container animate__animated animate__fadeInUp' data-aos="fade-up" data-aos-delay="100">
                                        <img src={about_1} alt="img" />
                                    </div>
                                    <div className='ab-img-2 carousel-container animate__animated animate__fadeInUp' data-aos="fade-up" data-aos-delay="100">
                                        <img src={about_2} alt="" />
                                    </div>
                                    <div className='ab-img-3 carousel-container animate__animated animate__fadeInUp' data-aos="fade-up" data-aos-delay="100">
                                        <img src={about_2_2} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className='about-us-text carousel-container animate__animated animate__fadeInRight' data-aos="fade-right" data-aos-delay="100">
                                <h1 className='about-us-title'>Our Story</h1>
                                <div className="about-us-context">
                                    <div>Our story began in 2018, driven by a vision to bridge the growing gap between scientific excellence and the digital tools needed to support it. At Lab Iconics Technologies, we recognized a pressing need within laboratories—especially in the pharmaceutical, biotechnology, research, and testing sectors—for smarter, more accessible solutions that could keep pace with the increasing complexity of regulatory demands and data management. </div>
                                    <div style={{paddingTop:'1rem'}}>Laboratories, despite being the backbone of scientific discovery and product development, often found themselves working with fragmented, outdated systems that slowed progress and introduced risk. From these challenges, our mission was born: to empower laboratories with reliable, user-friendly technology that simplifies their workflows and strengthens compliance.</div>
                                    <div style={{paddingTop:'1rem'}}>What began as a small, passionate team with a shared purpose has evolved into a trusted company serving labs across diverse scientific domains. Our journey has been shaped by more than just innovation—it has been fueled by a deep respect for the people who drive science forward every day. We’ve worked closely with our clients, learning from their real-world challenges and continuously improving our solutions to meet their evolving needs.</div>
                                    <div style={{padding:'1rem 0'}}>Over the years, we’ve grown not just in size, but in experience, capability, and impact—transforming complex problems into meaningful, practical tools that help laboratories operate more efficiently, ensure data integrity, and confidently meet global standards.</div>
                                    <div>Today, Lab Iconics stands as a symbol of purpose, persistence, and partnership. Our commitment goes beyond software; it lies in building lasting relationships, enabling digital transformation, and supporting the critical work being done in labs around the world. And as science continues to advance, our story continues—driven by the same dedication that inspired us from the very beginning.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="wwr-section" style={{padding:'5rem'}}>
                    <div className="wwr-wrapper">
                        <div className="wwr-content">
                            <div className="wwr-text" data-aos="fade-up" data-aos-delay="100">
                                <h1 className="wwr-title">Who We Are</h1>
                                <div className='wwr-context'>
                                We are professionals with expertise in Science, Technology, Engineering, Compliance, and Laboratory Applications, offering LIMS, ELN, QMS, and DMS solutions. Informactis serves Healthcare, Pharmaceutical, Biotechnology, Life Sciences, Food, Consumer Goods, and Polymer industries, as well as R&D and Educational Institutions. We help organizations digitize workflows, ensure data integrity, and maintain regulatory compliance enabling efficient, secure, and innovation-driven operations in complex, highly regulated environments.                                </div>
                            </div>
                            <div className="wwr-image-div" data-aos="fade-up" data-aos-delay="100">
                                <div className="wwr-img-placeholder">
                                    <img src={about_3} alt="img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="wwr-section" style={{padding:'0 5rem'}}>
                    <div className="wwr-wrapper">
                        <div className="wwr-content">
                            <div className="wwr-text" data-aos="fade-up" data-aos-delay="100">
                                <h1 className="wwr-title">What We Do</h1>
                                <div className='wwr-context'>
                                At Lab Iconics, we specialize in providing cutting-edge laboratory informatics solutions. Our commitment is to deliver comprehensive, secure, and compliant solutions customized to the dynamic needs of laboratories. With a focus on data integrity, security, and regulatory compliance, we provide seamless, efficient, and effective operations for our customers' laboratories.
                                </div>
                            </div>
                            <div className="wwr-image-div" data-aos="fade-up" data-aos-delay="100">
                                <div className="wwr-img-placeholder">
                                    <img src={about_5} alt="img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="vm-section" style={{padding:'5rem'}}>
                    <div className="vm-wrapper">
                        <div className="vm-content">
                            <div className='vm-vision-text' data-aos="fade-up" data-aos-delay="100">
                                <h1 className="vm-vision-title">Our Vision</h1>
                                <div className="vm-vision-context">
                                Our vision is to provide technology edge and compliance solutions, enabling our customers to deliver better products right on time.
                                </div>
                            </div>
                            <div className='vm-image-placeholder' data-aos="fade-up" data-aos-delay="100">
                                <img src={about_4} alt="vm-img" />
                            </div>
                            <div className='vm-mission-text' data-aos="fade-up" data-aos-delay="100">
                                <h1 className="vm-mission-title">Our Mission</h1>
                                <div className="vm-mission-context">
                                Our Mission is to deliver high-quality lab informatics and compliance solutions and recognize as a preferred <b> Single Point Solution Provider </b> in the industry.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="md-section" style={{background:'#eee'}}>
                    <div className="md-wrapper">
                        <div className="md-content">
                            <div className="md-image" data-aos="fade-up" data-aos-delay="100">
                                <div className="mg-image-circle">
                                    <img src={rabindranadth} alt="" />
                                </div>
                                <div className="md-desig" style={{paddingTop:'10px'}}>
                                    <h6 style={{margin:'0', textAlign:'center'}}>Raveendranath Govindaraj</h6>
                                    <p style={{marginBottom:'0', textAlign:'center'}}>Founder & Managing Partner</p>
                                </div>
                                <div className="md-social-media">
                                    <div className="md-social-links">
                                        <a href="https://twitter.com/labiconics" target="_blank" className="twitter" rel='noreferrer' style={{ background: '#47b2e4' }}><i className="bx bxl-twitter"></i></a>
                                        <a href="https://www.facebook.com/people/Lab-Iconics/100090394092719/?mibextid=LQQJ4d" target="_blank" className="facebook" rel='noreferrer' style={{ background: '#47b2e4' }}><i className="bx bxl-facebook"></i></a>
                                        <a href="https://www.linkedin.com/in/raveendranath-govindaraj-6791325/" target="_blank" rel='noreferrer' className="linkedin" style={{ background: '#47b2e4' }}><i className="bx bxl-linkedin"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div className="md-text" data-aos="fade-up" data-aos-delay="100">
                                <div>
                                    {/* <RiDoubleQuotesL size={60}/>  */}
                                    <img src={qouteIcon} alt="" style={{height:'3rem', transform:'rotate(180deg)'}}/> 
                                </div>
                                <div className="md-context">
                                Raveendranath Govindaraj, Founder & MD of Lab Iconics, brings 25+ years of expertise in lab automation, quality systems, and instrumentation. An engineer with an MBA in Technology Management, he is certified in ISO, NABL, and lab compliance standards. He is a recognized SME in 21 CFR Part 11, EU Annex 11, and CSV, with deep regulatory audit experience. Under his leadership, Lab Iconics delivers innovative, compliant solutions for pharmaceutical, Bio-Technology and Life science Industries.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="portfolio-details" className="portfolio-details">
                    <div className="container">
                        <div className="section-title">
                            <h1 style={{ fontWeight: 'bold', textAlign:'center' }}><b>GRATITUDE TO BIRAC</b></h1>
                        </div>
                        <div className="birac-section" data-aos="fade-up" data-aos-delay="100">
                            <div className="birac-section-one" data-aos="fade-up" data-aos-delay="100">
                                <div className="birac-img-1">
                                    <img src={birac} alt="" style={{ marginBottom: '10%' }} />
                                </div>
                                <div className="birac-img-2">
                                    <img src={nbm} alt="" style={{ marginTop: '5%' }} />
                                </div>
                                <div className="birac-img-3">
                                    <img src={dbtlogo} alt="" style={{ marginTop: '1%' }} />
                                </div>
                            </div>
                            <div className="col-lg-12 birac-section-two">
                                We are grateful to National Biopharma Mission, BIRAC, Department of Biotechnology, Govt. of India for their generous grant support, which has played a pivotal role in the development of Lab Iconics LIMS, Lab Iconics ELN and Lab Iconics ADBS. Their funding has empowered us to innovate and deliver cutting-edge solutions, enabling us to revolutionize laboratory management. With BIRAC's support, we continue to advance our mission of enhancing efficiency, compliance, and productivity in laboratories in India and worldwide.
                            </div>
                        </div>
                    </div>
                </section>


            <section id="portfolio-details" className="portfolio-details" data-aos="fade-up" data-aos-delay="100">
                <div className="container">
                    <div className="section-title">
                        <h1 style={{ fontWeight: 'bold', textAlign:'center' }}><b>AWARDS</b></h1>
                    </div>
                    <div className="row" style={{display:'flex', justifyContent:'center'}}>
                        <div className="col-sm-7">
                            <Carousel>
                                <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/s1.jpg')} alt="" style={{ width: '100%' }} />
                                </Carousel.Item>
                                 <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/pm1.jpg')} alt="" style={{width:'95%'}}/>
                                </Carousel.Item> 
                                <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/s7.jpg')} alt="" style={{ width: '100%' }} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/s5.jpg')} alt="" style={{ width: '100%' }} />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/s3.jpg')} alt="" style={{ width: '100%' }} />
                                </Carousel.Item>
                            </Carousel>
                        </div>
                    </div>
                    <div className="col-lg">
                        <div className="portfolio-description">
                            <ul className='awards-li'>
                                <li>Grant Award from National Biopharma Mission (NBM) - BIRAC, Department of Biotechnology, Govt. of India for the "Development of Quality Management System for Biopharmaceutical Industry". </li>
                                <li>Best Innovative Technology Award” from Indian Society of Analytical Scientists (ISAS) - 2022</li>
                                <li>MSMECCII Excellence Award - 2020</li>
                                <li>India 500 Startup Award - 2019</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>



            </section>

            {/* <div className="container">

                <div className="section-title text-center" data-aos="zoom-out">
                    <h1 style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }}>ABOUT</h1>
                </div>

                <div className="row content" data-aos="fade-up">
                    <div className="col-lg-4 pr-5 mt-5">
                        <h4 style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }}>WHO WE ARE</h4>
                        <p >
                            We are professionals with expertise in Science and Technology, Engineering, Compliance, Laboratory
                            Applications, and services for the Healthcare, Pharmaceutical, Biotechnology, Life Sciences, Food, Consumer
                            Goods, and Polymer Industries, as well as Research & Development and Educational Institutions.
                        </p>
                    </div>

                    <div className="col-lg-4 pl-5 pr-5 mt-5">
                        <h4 style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }}>WHAT WE DO</h4>
                        <p>
                            At Lab Iconics, we specialize in providing cutting-edge laboratory informatics solutions. Our commitment is to deliver comprehensive, secure, and compliant solutions customized to the dynamic needs of laboratories. With a focus on data integrity, security, and regulatory compliance, we provide seamless, efficient, and effective operations for our customers' laboratories.
                        </p>
                    </div>

                    <div className="col-lg-4 pl-5 mt-5">
                        <h4 style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }}>OUR VISION AND MISSION</h4>
                        <p><b>Vision:</b>
                            Our vision is to provide technology edge and compliance solutions, enabling our customers to deliver better products right on time.
                        </p>

                        <p><b>Mission:</b>

                            Our Mission is to deliver high-quality lab informatics and compliance solutions and recognize as a preferred "Single Point Solution Provider" in the industry.
                        </p>
                    </div>
                </div>

                <div className="text-center mt-5 mb-5" data-aos="zoom-out">
                    <h1 style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }}><b>LEADERSHIP TEAM</b></h1>
                </div>

                <div className="row" data-aos="fade-up">
                    <div className="col-lg-6 mt-5">
                        
                        <div className='order-sm-2 order-lg-1'>
                            <p className="" style={{ fontSize: '17px', fontFamily: 'Arial' }}>
                                Raveendranath Govindaraj, the Founder and Managing Director of Lab Iconics, which was founded in 2018. With a background in Engineering and an MBA in Technology Management, Raveendranath brings over 25 years of extensive experience in Quality systems, Instrumentation, and Laboratory Automation across pharmaceutical, analytical, life science, and lab informatics industries.
                                Throughout his career, Raveendranath has successfully navigated numerous audits from regulatory agencies including USFDA, MHRA, WHO, and others, showcasing his expertise in ensuring compliance and quality standards. He holds certifications as a DNV Certified Auditor for ISO 14001, and is certified in "Laboratory Management System & Internal Auditing", ISO/IEC 17025:2017, and NABL Requirements.
                                Raveendranath is a Subject Matter Expert (SME) in Lab Compliance, specializing in 21 CFR Part 11, EU Annex 11, and CSV (Computer System Validation). He has spearheaded the implementation of various IT applications, networking solutions, and data management systems including SDMS, LIMS, ELN, QMS, and DMS.
                                His visionary leadership and profound knowledge have been instrumental in shaping Lab Iconics as a leading provider of innovative solutions in the laboratory technology space.

                            </p>
                        </div>
                    </div>

                    <div className="col-lg-5 order-sm-1 order-lg-2 d-flex flex-column justify-content-center" >
                        <img src={rabindranadth} alt="Raveendranath Govindaraj" className='ravi' />
                        <div className='text-center pl-5 m-3'>
                            <h3 className='text-left mb-3 pl-5' style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }}>Raveendranath Govindaraj</h3>
                            <h4 className='text-left mb-3 pl-5' style={{ color: 'rgba(4,52,111)' }}>Founder & Managing Director</h4>
                        </div>
                    </div>
                </div>

            </div> */}

            {/* <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    <div className="section-title">
                        <h2>Acknowledgement</h2><br></br>
                        <h1 style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }}><b>GRATITUDE TO BIRAC</b></h1>
                    </div>
                    <div className="container">
                        <div className="row content" data-aos="fade-up">
                            <div className="col-lg-4 pr-5 mt-5">
                                <img src={birac} alt="" style={{ width: '22vw', marginBottom: '10%' }} />
                            </div>

                            <div className="col-lg-4 pl-5 pr-5 mt-5">
                                <img src={nbm} alt="" style={{ width: '22vw', marginTop: '5%' }} />
                            </div>

                            <div className="col-lg-4 pl-5 mt-5">
                                <img src={dbtlogo} alt="" style={{ width: '22vw', marginTop: '1%' }} />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="portfolio-description">

                            <p >
                                <li style={{ listStyleType: 'none' }}>We are grateful to National Biopharma Mission, BIRAC, Department of Biotechnology, Govt. of India for their generous grant support, which has played a pivotal role in the development of Lab Iconics LIMS, Lab Iconics ELN and Lab Iconics ADBS. Their funding has empowered us to innovate and deliver cutting-edge solutions, enabling us to revolutionize laboratory management. With BIRAC's support, we continue to advance our mission of enhancing efficiency, compliance, and productivity in laboratories in India and worldwide.</li>
                            </p>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <section id="portfolio-details" className="portfolio-details">
                <div className="container">
                    <div className="section-title">
                    <h1 style={{ fontWeight: 'bold', color: 'rgba(4,52,111)' }}><b>AWARDS</b></h1>
                    </div>
                    <div className="row">
                        <div className="col-sm-7">
                            <Carousel>
                                <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/s1.jpg')} alt="" style={{ width: '100%' }} />

                                </Carousel.Item>
                                 <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/pm1.jpg')} alt="" style={{width:'95%'}}/>
                                </Carousel.Item> 
                                <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/s7.jpg')} alt="" style={{ width: '100%' }} />

                                </Carousel.Item>
                                <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/s5.jpg')} alt="" style={{ width: '100%' }} />

                                </Carousel.Item>
                                <Carousel.Item>
                                    <img src={require('../assets/img/portfolio/s3.jpg')} alt="" style={{ width: '100%' }} />

                                </Carousel.Item>
                            </Carousel>

                        </div>
                        <div className="col-lg-5">
                            <div className="portfolio-description">
                                <h2></h2>
                                <h2></h2>
                                <ul className='awards-li'>
                                    <li>Grant Award from National Biopharma Mission (NBM) - BIRAC, Department of Biotechnology, Govt. of India for the "Development of Quality Management System for Biopharmaceutical Industry". </li>
                                    <li>Best Innovative Technology Award” from Indian Society of Analytical Scientists (ISAS) - 2022</li>
                                    <li>MSMECCII Excellence Award - 2020</li>
                                    <li>India 500 Startup Award - 2019</li>
                                </ul>
                                <p>

                                    <li>Grant Award from National Biopharma Mission (NBM) - BIRAC, Department of Biotechnology, Govt. of India for the "Development of Quality Management System for Biopharmaceutical Industry". </li>

                                    <li>Grant Award from National Biopharma Mission (NBM) - BIRAC, Department of Biotechnology, Govt. of India for the "Development of Quality Management System for Biopharmaceutical Industry". </li>
                                </p>
                                <p>
                                    <li>Best Innovative Technology Award” from Indian Society of Analytical Scientists (ISAS) - 2022</li>

                                </p>
                                <p>

                                    <li>MSMECCII Excellence Award - 2020</li>

                                </p>
                                <p>

                                    <li>India 500 Startup Award - 2019</li>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            
            {/* <div id="scroll-wrapper">
                <div id="image-container">
                    <img className="image" alt='' src={require('../assets/img/clients/FDA.png')} />
                    <img className="image" alt='' src={require('../assets/img/clients/aloca.png')} />
                    <img className="image" alt='' src={require('../assets/img/clients/clia.png')} />
                    <img className="image" alt='' src={require('../assets/img/clients/eu11.png')} />
                    <img className="image" alt='' src={require('../assets/img/clients/gxp.png')} />
                    <img className="image" alt='' src={require('../assets/img/clients/hippa.png')} />
                    <img className="image" alt='' src={require('../assets/img/clients/iso.png')} />
                    <img className="image" alt='' src={require('../assets/img/clients/ispe.png')} />

                </div>
            </div> */}
            


            {/* <div style={{ width: '70vw', margin: '0 auto' }}>
                <div className="section-titlee text-center mt-5">
                    <p></p>
                </div>
                <div className="section-title">
                    <h3>Awards</h3>
                </div>
                <div className="services mt-5">
                    <div className="container services mt-5" >
                        <div className="row">

                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box" data-aos="zoom-in-left" data-aos-delay="300">

                                    <h4 className="title" style={{ color: 'rgba(4,52,111)' }}><a >Project Management</a></h4>
                                    <p className="description">The project management in LAB ICONICS ELN plays a key role in managing the experiments under respective projects by, assigning the projects to the respective groups.</p>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mt-5">
                                <div className="icon-box" data-aos="zoom-in-left" data-aos-delay="400">

                                    <h4 className="title" style={{ color: 'rgba(4,52,111)' }}><a >Forms & Templates</a></h4>
                                    <p className="description">The features in the LAB ICONICS ELN includes Configurable forms and templates, which helps in saving an ample of time by updating / entering the required details in standard template or forms. </p>
                                </div>
                            </div>

                            <div className='core-values-container text-center ml-5 mr-5'>
                                <Row className="justify-content-center">
                                    {awards.slice(0, showAllAwards ? awards.length : 2).map((award) => (
                                        <Col key={award.id} md={6} className="core-value d-flex flex-column">
                                            <div className='shadow-lg text-center p-5 flex-grow-1 mt-4' style={{ backgroundColor: showAllAwards ? 'info' : '', transition: 'background-color 0.3s ease' }}>
                                                <FontAwesomeIcon icon={faAward} size="4x" className={showAllAwards ? 'text-gold' : 'text-info'} style={{ transition: 'color 0.3s ease' }} />
                                                <h3 className='mt-2'><b>{award.title}</b></h3>
                                                <p className='mt-3'>{award.description}</p>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='core-values-container text-center ml-5 mr-5'>
                    <Row className="justify-content-center">
                        {awards.slice(0, showAllAwards ? awards.length : 2).map((award) => (
                            <Col key={award.id} md={6} className="core-value d-flex flex-column">
                                <div className='shadow-lg text-center p-5 flex-grow-1 mt-4' style={{ backgroundColor: showAllAwards ? 'info' : '', transition: 'background-color 0.3s ease' }}>
                                    <FontAwesomeIcon icon={faAward} size="4x" className={showAllAwards ? 'text-gold' : 'text-info'} style={{ transition: 'color 0.3s ease' }} />
                                    <h3 className='mt-2'><b>{award.title}</b></h3>
                                    <p className='mt-3'>{award.description}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>

                {!showAllAwards && (
                    <div className="text-center mt-5">
                        <button className="explore-button bg-info text-light rounded-3 pl-5 pt-2 pb-2 pr-5 mb-2" onClick={handleExploreAwardsClick}>
                            Explore More Awards
                        </button>
                    </div>
                )}
            </div> */}
        </main>


        {/* <svg className="hero-waves" style={{ background: 'rgb(4,52,111)' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28" preserveAspectRatio="none">
            <defs>
                <path id="wave-path" d="M-160 44c30 0 58-18 88-18s58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g className="wave1">
                <use xlinkHref="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
            </g>
            <g className="wave2">
                <use xlinkHref="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
            </g>
            <g className="wave3">
                <use xlinkHref="#wave-path" x="50" y="9" fill="#fff" />
            </g>
        </svg> */}
    </div>

    );
};

export default About;